export default {"src":"/_next/static/media/bg-image.be585c99.svg","height":570,"width":576,"blurWidth":0,"blurHeight":0};